module.exports = __webpack_public_path__ + "img/illustration-forgot-password-light.cc20f352.jpg";